import styled from 'styled-components';

export const PanelContent = styled.div`
  box-sizing: border-box;
  padding: 0 ${({ theme }) => `${theme.size.spacing.large.value} ${theme.size.spacing.large.value}`};
`;
